module.exports = __webpack_public_path__ + "img/img63.e19aed39.png";